export default {
  market: {
    Applicant: 'Applicant',
    ApplyTime: 'Apply Time',
    AuditPass: 'Audit Pass',
    AuditFailed: 'Audit Failed',
    NotAudit: 'Not Audit',
    ContactMethod: 'Contact Method',
    AuditStatus: 'Audit Status',
    ActivityName: 'Activity Name',
    ActivityContent: 'Activity Content',
    Location: 'Location',
    ApplicationTime: 'Application Time',
    ActivityMember: 'Activity Member',
    ActivityCode: 'Activity Code',
    AvtivityStore: 'Avtivity Store',
    ChooseDataFirst: 'Choose Data First'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/mmc/eurlate/market.js